/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AuthService, ConfigService } from 'sis-common';
import { NavUtilsService } from '../../service/nav-utils.service';

@Component({
    selector: 'sis-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LogoutComponent implements OnInit {
    @Input() mobileMode = false;

    @Output() keydownPressed = new EventEmitter<any>();
    @Output() blurLogout = new EventEmitter<any>();

    logoutUrl: string;

    constructor(
        private configService: ConfigService,
        private navUtilsService: NavUtilsService,
        private authService: AuthService,
    ) {}

    ngOnInit() {
        this.logoutUrl = this.getLogoutUrl();
    }

    logout() {
        this.authService.clear();
    }

    private getLogoutUrl(): string {
        let logoutUrl = '';
        const universityConfig = this.configService.get();

        if (universityConfig.logoutUrl) {
            const logoutUrlPrefix = (universityConfig.logoutUrl || '').startsWith('http') ? '' : window.location.origin;
            const targetUrl = `${window.location.origin}${this.navUtilsService.getContextPath()}/logout`;

            logoutUrl = `${logoutUrlPrefix}${universityConfig.logoutUrl}${targetUrl}`;
        }

        return logoutUrl;
    }
}
